const messagesRu = {
  about: 'О нас',
  acceptanceCriteria: 'Критерии приемки',
  accomplishments: 'Достижения',
  actions: 'Действия',
  activity: 'Активность',
  activatePod: 'Активировать POD',
  activePods: 'Активные POD',
  add: 'Добавить',
  addBlocker: 'Добавить информацию о блокировке',
  addingCandidateWait: 'Добавление кандидата, пожалуйста подождите...',
  addPortfolio: 'Добавить портфолио',
  addStakeholder: 'Добавить заинтересованное лицо',
  addVideoUpdate: 'Добавить видео обновление',
  findAgents: 'Найти агентов',
  all: 'Все',
  allReporters: 'Все репортеры',
  allRepoCheckins: 'Все проверки репозитория',
  approve: 'Одобрить',
  approved: 'Одобрено',
  approvalRequests: 'Запросы на одобрение',
  approvedPRCount: 'Количество одобренных PR',
  assignedItems: 'Назначенные элементы',
  availability: 'Доступность',
  availableDate: 'Доступная дата',
  backToPods: 'Вернуться к моим POD',
  basicInformation: 'Основная информация',
  blocker: 'Блокировка',
  blockerDetails: 'Детали блокировки',
  blockers: 'Блокировки',
  board: 'Доска',
  browseTalent: 'Просмотр талантов',
  bugs: 'Баги',
  calendlyUrl: 'URL Calendly',
  cancel: 'Отменить',
  candidates: 'Кандидаты',
  categories: 'Категории',
  certifications: 'Сертификации',
  certificationUrl: 'URL сертификации',
  checkBoxBlocker: 'Отметьте этот флажок, если это блокировка',
  ciCdPipeline: 'CI/CD конвейер',
  clear: 'Очистить',
  client: 'Клиент',
  clickHereUploadVideoClip: 'Нажмите здесь, чтобы загрузить видеоклип!',
  cloudCost: 'Стоимость облака',
  code: 'Строки кода',
  codeSmells: 'Запахи кода',
  commentHere: 'комментировать здесь...',
  category: 'Категория',
  comments: 'Комментарии',
  companyName: 'Название компании',
  copied: 'Скопировано!',
  copyright: 'Авторские права © 2025-настоящее время Brilli Global, Inc. Все права защищены.',
  copyToClipboard: 'Скопировать в буфер обмена',
  cost: 'Стоимость',
  costDetails: 'Детали стоимости',
  country: 'Страна',
  create: 'Создать',
  createArt: 'Создать ART',
  createGig: 'Создать решение',
  createPod: 'Создать POD',
  createProfile: 'Создать профиль',
  createProfileOpportunity: 'Создайте свой профиль в нашей базе данных талантов, чтобы быть включенным в различные возможности удаленной работы.',
  createTask: 'Создать задачу',
  createYourOwnPod: 'Создайте свой собственный POD и просматривайте проекты',
  creatingProfile: 'Создание профиля',
  currency: 'Валюта',
  currentlyAvailable: 'В настоящее время доступен',
  currentWeek: 'Текущая неделя',
  dashboard: 'Панель управления',
  date: 'Дата',
  dateRangeFilter: 'Фильтр диапазона дат',
  deactivatePod: 'Деактивировать POD',
  deactivateToUpdate: 'Деактивируйте POD для обновления POD!',
  defects: 'Дефекты',
  delete: 'Удалить',
  deletePod: 'Удалить POD',
  description: 'Описание',
  detailsForGitHubRepo: 'Детали для GitHub репозитория',
  done: 'закрыть',
  Done: 'ВЫПОЛНЕНО',
  doraMetrics: 'Метрики Dora',
  dueDate: 'Срок выполнения',
  duplicatedLinesDensity: 'Плотность дублированных строк',
  edit: 'Редактировать',
  education: 'Образование',
  educationAndCertifications: 'Образование и сертификации',
  email: 'Электронная почта',
  podTime: 'Время POD',
  createHub: 'Создать хаб',
  createSolution: 'Создать решение',
  podVelocity: 'Скорость POD',
  podBlockers: 'Блокировки POD',
  podsync: 'Синхронизация POD',
  endDate: 'Дата окончания',
  enterEmailToInvite: 'Введите электронную почту для приглашения',
  enterPodMission: 'Введите миссию POD',
  enterPodName: 'Введите название POD',
  enterStoryDescription: 'Введите описание истории',
  executionDate: 'Дата выполнения',
  executionID: 'ID выполнения',
  externalPod: 'Внешний POD',
  fileNameNoSpaces: 'Имя файла не должно содержать пробелов между всеми элементами или символами',
  fileUpload: 'Загрузка файла',
  findBestFreelancers: 'Найдите лучших фрилансеров или команды талантов, чтобы ваши проекты выполнялись быстрее!',
  findBestPod: 'Найдите POD, которые соответствуют вашему опыту/навыкам',
  findPods: 'Найти POD',
  findTalent: 'Найти таланты',
  findYourBestTalentPod: 'Найдите свой лучший POD талантов',
  firstName: 'Имя',
  focus: 'Фокус',
  gitHubRepo: 'GitHub репозиторий',
  gitHubUsername: 'Имя пользователя GitHub',
  github: 'Github',
  githubSummary: 'Сводка GitHub',
  githubUrl: 'URL Github',
  githubUser: 'Пользователь GitHub',
  giveRating: 'Дать оценку',
  globalWorkPlatform: 'Глобальная рабочая платформа',
  home: 'Главная',
  hoursPerWeek: 'Часов в неделю',
  inactivePod: 'Неактивный POD',
  individual: 'Индивидуальный',
  industry: 'Отрасль',
  inProgress: 'В ПРОЦЕССЕ',
  institute: 'Институт',
  internalPod: 'Внутренний POD',
  invite: 'Пригласить',
  invoices: 'Счета',
  issueKey: 'Ключ задачи',
  issueStatus: 'Статус задачи',
  issueSummary: 'Сводка задачи',
  jiraIssue: 'Задача Jira',
  jiraIssues: 'Задачи Jira',
  jiraItem: 'Элемент Jira',
  jiraTimeDetails: 'Журнал времени',
  jiraUsername: 'Имя пользователя Jira',
  keepDoing: 'Продолжайте делать',
  keyword: 'Ключевое слово',
  languageSpoken: 'Язык общения',
  lastName: 'Фамилия',
  latestSprintVelocity: 'Последняя скорость спринта',
  linkedIn: 'LinkedIn',
  linkedInUrl: 'URL LinkedIn',
  linesOfCodeByDay: 'Строки кода по дням',
  listOfTalents: 'Список талантов',
  loading: 'Загрузка',
  loadingAcceptanceCriteria: 'Загрузка критериев приемки',
  loadingStoryDescription: 'Загрузка описания истории',
  loadingTestCases: 'Загрузка тестовых случаев',
  logOut: 'Выйти',
  login: 'Войти',
  manage: 'Управлять',
  manageActivities: 'Управляйте своими ежедневными активностями POD и обновлениями',
  manageProfile: 'Управление профилем',
  manageProfileHere: 'Управляйте своим профилем здесь',
  managePod: 'Управление POD',
  managePods: 'Управляйте всеми своими POD и их активностями',
  markComplete: 'Отметить как выполненное',
  middleName: 'Отчество',
  myPods: 'Мои POD',
  myTasks: 'Мои задачи',
  name: 'Имя',
  ncloc: 'Ncloc',
  newActivityUpdate: 'Новое обновление активности',
  next: 'Следующий',
  noArtOptionsAvailable: 'Нет доступных опций ART',
  noBlockers: 'Нет блокировок',
  noCandidates: 'Кандидаты не добавлены',
  noCandidatesAddedToPod: 'В POD не добавлены кандидаты!',
  noCandidateReviews: 'Нет отзывов о кандидатах.',
  noData: 'Нет данных',
  noDataAvailable: 'Данные недоступны',
  noExperience: 'Нет опыта',
  noMatchingPods: 'Нет доступных соответствующих POD',
  noNotifications: 'Нет уведомлений',
  noPodActivity: 'У вас нет активности POD',
  noPods: 'У вас нет POD',
  noPodTasks: 'У вас нет задач POD',
  noReviews: 'Нет отзывов.',
  noStakeholders: 'Нет заинтересованных лиц для этого POD',
  noSubscription: 'У вас нет плана подписки',
  noVideoAvailable: 'Видео недоступно',
  notifications: 'Получатель уведомлений',
  otherInformation: 'Другая информация',
  pending: 'Ожидает',
  pendingPods: 'Ожидающие POD',
  phoneNumber: 'Номер телефона',
  pipelineExecutionDetails: 'Детали выполнения конвейера',
  pipelineName: 'Название конвейера',
  pipelineVersion: 'Версия конвейера',
  pleaseEnterStoryDescription: 'Пожалуйста, введите описание истории и нажмите отправить',
  POD: 'POD',
  podActivities: 'Активности POD',
  podActivity: 'Активность POD',
  podAnalytics: 'Аналитика POD',
  podAssist: 'Помощник POD',
  podAutomation: 'Автоматизация POD',
  podBoard: 'Доска POD',
  podCategories: 'Категории POD',
  podDescription: 'Описание POD',
  podExperience: 'Опыт POD',
  podFeedback: 'Обратная связь POD',
  podMetrics: 'Метрики POD',
  podName: 'Название POD',
  podQuery: 'Запрос POD',
  podRequests: 'ЗАПРОСЫ POD',
  podRetro: 'Ретроспектива POD',
  podSize: 'Размер POD',
  podTasks: 'Задачи POD',
  podTaskDescription: 'Описание задачи POD',
  podTaskDueDate: 'Срок выполнения задачи POD',
  podTaskName: 'Название задачи POD',
  podTaskOwner: 'Владелец задачи POD',
  podTaskStatus: 'Статус задачи POD',
  podTechStack: 'Технологический стек POD',
  podTeamMember: 'Член команды POD',
  podType: 'Тип POD',
  portfolio: 'Портфолио',
  portfolioUrl: 'URL портфолио',
  post: 'Опубликовать',
  postActivity: 'Опубликовать активность',
  postPodActivity: 'Опубликовать активность POD',
  postRequirement: 'Опубликовать требование',
  posting: 'Публикация...',
  postedDate: 'Дата публикации',
  postedRequirements: 'Ваши опубликованные требования POD',
  positionName: 'Название позиции',
  prCount: 'Количество PR',
  preferredWorkHours: 'Предпочитаемые рабочие часы',
  prev: 'Предыдущий',
  previousPods: 'Предыдущие POD',
  previousWeek: 'Предыдущая неделя',
  primarySkill: 'Основной навык',
  privacyPolicy: 'Политика конфиденциальности',
  privatePods: 'Частные POD',
  prSummary: 'Сводка PR',
  projectKey: 'Ключ проекта',
  profileLink: 'Ссылка на профиль',
  profileVisibility: 'Видимость профиля',
  public: 'Публичный',
  qualification: 'Квалификация',
  ratePerHour: 'Ставка в час',
  ratePerMonth: 'Ставка в месяц',
  recentSearches: 'Недавние поиски',
  region: 'Регион',
  register: 'Зарегистрироваться',
  resetPassword: 'Сбросить пароль',
  restricted: 'Ограниченный',
  retro: 'Ретроспектива',
  review: 'Отзыв и рейтинг',
  revisionSummary: 'Сводка редакции',
  revisionURL: 'URL редакции',
  resume: 'Резюме',
  resumeLink: 'Просмотреть резюме',
  rowsPerPage: 'Строк на странице',
  save: 'Сохранить',
  search: 'Поиск',
  searchProjects: 'Поиск проектов',
  secondarySkill: 'Дополнительный навык',
  select: 'Выбрать',
  selectArtName: 'Выбрать название ART',
  selectAUser: 'Выбрать пользователя',
  selectFilter: 'Выбрать фильтр',
  applyFilters: 'Применить фильтры',
  selectItemsPerPage: 'Выбрать элементов на странице',
  selectJiraIssues: 'Выбрать задачи Jira',
  selectPod: 'Выбрать POD',
  selectPodTeamMember: 'Выбрать члена команды POD',
  selectPods: 'Выбрать POD',
  services: 'Услуги',
  setting: 'Настройка',
  shareableLink: 'Ссылка для совместного доступа',
  signUpToGetStarted: '"Зарегистрируйтесь" ниже, чтобы начать!',
  getStarted: 'Начать',
  skills: 'Навыки',
  skillsAndExpertise: 'Навыки и экспертиза',
  sonarqubeprojectkey: 'Ключ проекта Sonarqube',
  sonarqubeStats: 'Статистика Sonarqube',
  specialization: 'Специализация',
  sprintVelocity: 'Скорость спринта',
  sprint: 'Спринт',
  spotsLeft: 'Осталось мест',
  startDate: 'Дата начала',
  startDoing: 'Начните делать',
  status: 'Статус',
  stopDoing: 'Прекратите делать',
  storyDescription: 'Описание истории',
  stories: 'Истории',
  submit: 'Отправить',
  submittedDate: 'Дата отправки',
  submittedPRCount: 'Количество отправленных PR',
  subscription: 'Подписка',
  talentApprovalRequests: 'Запросы на одобрение талантов',
  talentCode: 'Код таланта',
  taskForm: 'Форма задачи',
  taskManager: 'Менеджер задач',
  taskName: 'Название задачи',
  tasks: 'Задачи',
  teamMember: 'Член команды',
  techStack: 'Технологический стек',
  termsOfService: 'Условия обслуживания',
  testCases: 'Тестовые случаи',
  time: 'Время',
  timeLog: 'Журнал времени',
  timeSubmit: 'Отправка времени',
  timeZone: 'Часовой пояс',
  toDo: 'К ВЫПОЛНЕНИЮ',
  todaysFocus: 'Фокус сегодня',
  totalLinesChangedLastWeek: 'Общее количество измененных строк на прошлой неделе',
  totalLinesChangedThisWeek: 'Общее количество измененных строк на этой неделе',
  totalPRCount: 'Общее количество PR',
  university: 'Университет',
  update: 'Обновить',
  updateProfileHere: 'Обновите свой профиль здесь',
  updatingVisibility: 'Обновление видимости...',
  upload: 'Загрузить',
  userStory: 'Пользовательская история',
  validFrom: 'Действительно с',
  validTill: 'Действительно до',
  talentexplorer: 'Исследователь талантов',
  interviewrequests: 'Запросы на интервью',
  videoUrl: 'URL видео',
  view: 'Просмотр',
  viewActivities: 'Просмотр активностей',
  viewDetails: 'Просмотр деталей',
  viewPodActivities: 'Просмотр активностей POD',
  viewPodDetails: 'Просмотр деталей POD',
  viewProfile: 'Просмотр профиля',
  viewTasks: 'Просмотр задач',
  viewTimeEntries: 'Просмотр записей времени',
  viewVideo: 'Просмотр видео',
  visitFindTalent: 'Пожалуйста, посетите страницу "Найти таланты" и добавьте талантливых людей в свой POD.',
  vulnerabilities: 'Уязвимости',
  welcome: 'Добро пожаловать в Artemy.ai!',
  workExperience: 'Опыт работы',
  yourPod: 'Ваш POD',
  yourPods: 'Ваши POD',
  yourPostedPodActivity: 'Ваша опубликованная активность POD',
  
  findTickets: 'Найти тикеты',
  epics: 'Эпики',
  date: 'Дата',
  talent: 'Талант',
  focus: 'Фокус',
  startDate: 'Дата начала',
  endDate: 'Дата окончания',
  status: 'Статус',
  allStatus: 'Все статусы',
  blocked: 'Заблокировано',
  onTrack: 'На правильном пути',
  activityDetails: 'Детали активности',
  jiraIssues: 'Задачи Jira',
  todaysFocus: 'Фокус сегодня',
  accomplishments: 'Достижения',
  blockers: 'Блокировки',
  videoUpdate: 'Видео обновление',
  comments: 'Комментарии',
  addBlockerInformation: 'Добавить информацию о блокировке',
  blockerDetails: 'Детали блокировки',
  cancel: 'Отменить',
  saveChanges: 'Сохранить изменения',
  selectJiraIssues: 'Выбрать задачи Jira',
  design: 'Дизайн',
  development: 'Разработка',
  testing: 'Тестирование',
  bugFix: 'Исправление бага',
  documentation: 'Документация',
  myPods: 'Мои POD',
  postRetro: 'Опубликовать ретроспективу',
  newRetro: 'Новая ретроспектива',
  startDoing: 'Начните делать',
  stopDoing: 'Прекратите делать',
  keepDoing: 'Продолжайте делать',
  viewRetros: 'Просмотр ретроспектив',
  podRetroFeedback: 'Обратная связь ретроспективы POD',
  selectSprint: 'Выбрать спринт',
  thisTaskIsBlocker: 'Эта задача является блокировкой',
  category: 'Категория',
  taskCreatedSuccessfully: 'Задача успешно создана!',
  taskManagement: 'Управление задачами',
  searchJiraIssues: 'Поиск задач JIRA...',
  creatingTask: 'Создание задачи...',
  createTask: 'Создать задачу',
  description: 'Описание',
  dueDate: 'Срок выполнения',
  commentsHistory: 'История комментариев',
  noCommentsYet: 'Пока нет комментариев',
  writeAComment: 'Написать комментарий...',
  all: 'Все',
  blockerStatus: 'Статус блокировки',
  blockedTasks: 'Заблокированные задачи',
  unblockedTasks: 'Разблокированные задачи',
  clearDateRange: 'Очистить диапазон дат',
  selectDateRange: 'Выбрать диапазон дат',
  showAllTime: 'Показать все время',
  noTasksFound: 'Задачи не найдены',
  noLinkedIssues: 'Нет связанных задач',
  timeSheet: 'Табель учета времени',
  podTimeSheet: 'Табель учета времени POD',
  userStory: 'Пользовательская история',
  hours: 'Часы',
  minutes: 'Минуты',
  actions: 'Действия',
  submitTimeEntries: 'Отправить записи времени',
  selectCategory: 'Выбрать категорию',
  selectStory: 'Выбрать историю',
  addRow: 'Добавить строку',
  podSelection: 'Выбор POD',
  selectPodToView: 'Выберите POD для просмотра фильтров спринта и талантов',
  toDo: 'К выполнению',
  podAssist: 'Помощник POD',
  inProgress: 'В процессе',
  done: 'Выполнено',
  selectPodsRequired: 'Выбрать POD (обязательно)',
  enterStoryDescription: 'Введите описание истории',
  podSyncSummaries: 'Сводки синхронизации POD',
  enterMeetingUrl: 'Введите URL встречи...',
  searchInSummaries: 'Поиск в сводках...',
  dateAndTime: 'Дата и время',
  quickTimeRange: 'Быстрый диапазон времени',
  sortByDate: 'Сортировать по дате',
  selectTalents: 'Выбрать таланты',
  filterBySpecificCandidates: 'Фильтр по конкретным кандидатам (необязательно)',
  talentSelection: 'Выбор талантов',
  priority: 'Приоритет',
  addComment: 'Добавить комментарий',
  taskDetails: 'Детали задачи',
  summary: 'Сводка',
  addMeeting: 'Добавить встречу',

  podAutomation: 'Автоматизация POD',
  uploading: 'Загрузка...',
  uploadFile: 'Загрузить файл',
  send: 'Отправить',
  submitting: 'Отправка...',
  enterYourQuestionHere: 'Введите ваш вопрос здесь',
  submitTheResults: 'Отправить результаты',
  export: 'Экспорт',
  podInsights: 'Аналитика POD',
  askQuestionsAboutYourPod: 'Задавайте вопросы о ваших активностях POD, членах команды и многом другом',
  welcomeToPodInsights: 'Добро пожаловать в аналитику POD!',
  startByAskingQuestionsLike: 'Начните с вопросов наподобие',
  showAllPodActivitiesThatHadBlockers: 'Показать все активности POD, которые имели блокировки',
  listAllCandidatesAndTheirPods: 'Перечислить всех кандидатов и их POD',
  showStakeholdersFromIndia: 'Показать заинтересованных лиц из Индии',
  askAnythingAboutYourPods: 'Задавайте любые вопросы о ваших POD, членах команды, активностях...',
  sending: 'Отправка...',
  analyzingYourQuestion: 'Анализ вашего вопроса...',
  pipelineCICD: 'Конвейер CI/CD',
  tickets: 'Тикеты',
  metricName: 'Название метрики',
  metricValue: 'Значение метрики',
  commentsHistory: 'История комментариев',
  noCommentsYet: 'Пока нет комментариев',
  writeAComment: 'Написать комментарий...',
  solutionManagement: 'Управление решениями',
  searchSolutions: 'Поиск решений...',
  refresh: 'Обновить',
  createNewSolution: 'Создать новое решение',
  solutionName: 'Название решения',
  solutionDescription: 'Описание решения',
  updateSolution: 'Обновить решение',
  createSolution: 'Создать решение',
  confirmSolutionDeletion: 'Вы уверены, что хотите удалить решение',
  artManagement: 'Управление ART',
  podManagement: 'Управление POD',
  searchPods: 'Поиск POD...',
  viewPod: 'Просмотр POD',
  searchARTs: 'Поиск ART...',
  noARTsFound: 'ART не найдены. Создайте свой первый ART, нажав кнопку "Создать новый ART".',
  createNewART: 'Создать новый ART',
  selectGig: 'Выбрать проект',
  artName: 'Название ART',
  artDescription: 'Описание ART',
  createART: 'Создать ART',
  confirmDeletion: 'Подтвердить удаление',
  confirmARTDeletion: 'Вы уверены, что хотите удалить ART',
  primaryLanguage: 'Основной язык',
  selectSkills: 'Выбрать навыки',
  timeZone: 'Часовой пояс',
  updateART: 'Обновить ART',
  somethingWentWrong: 'Что-то пошло не так',
  reloadPage: 'Перезагрузить страницу',
  privatePods: 'Частные POD',
  activePods: 'Активные POD',
  completedPods: 'Завершенные POD',
  pendingPods: 'Ожидающие POD',
  loadingPods: 'Загрузка POD...',
  retry: 'Повторить',
  noPodsFound: 'POD не найдены',
  createFirstPod: 'Создайте свой первый POD для начала',
  previous: 'Предыдущий',
  showing: 'Показано',
  size: 'Размер',
  teamSize: 'Размер команды',
  activeMembers: 'Активные участники',
  stakeholders: 'Заинтересованные лица',
  podManagers: 'Менеджеры POD',
  addManager: 'Добавить менеджера',
  podManager: 'Менеджер POD',
  noManagersAssignedYet: 'Менеджеры еще не назначены',
  addManagersToHelpOversee: 'Добавьте менеджеров для помощи в надзоре за этим POD',
  noStakeholdersYet: 'Заинтересованных лиц пока нет',
  settings: 'Настройки',
  deletePod: 'Удалить POD',
  addPodManager: 'Добавить менеджера POD',
  selectManagerToInvite: 'Выберите менеджера для приглашения в этот POD:',
  noManagersAvailableToInvite: 'Нет доступных менеджеров для приглашения.',
  selectAManager: 'Выбрать менеджера',
  selectedManager: 'Выбранный менеджер',
  inviteManager: 'Пригласить менеджера',
  noTeamMembersYet: 'Членов команды пока нет',
  startByInvitingMembers: 'Начните с приглашения участников в ваш POD',
  inviteTeamMembers: 'Пригласить членов команды',
  existingMembers: 'Существующие участники',
  inviteByEmail: 'Пригласить по электронной почте',
  searchByNameOrSkills: 'Поиск по имени или навыкам...',
  optionalSelectUserToNotify: 'Необязательно: Выберите пользователя для уведомления через Slack',
  pleaseSelectPodToEnableFields: 'Пожалуйста, выберите POD для активации других полей',
  selectedCandidates: 'Выбранные кандидаты',
  selectCandidatesToInvite: 'Выберите кандидатов для приглашения в этот POD',
  availableCandidates: 'Доступные кандидаты',
  inviteNewMembersByEmail: 'Пригласить новых участников по электронной почте',
  emailAddresses: 'Адреса электронной почты',
  enterEmailAddresses: 'Введите адреса электронной почты (разделенные запятыми)',
  hidePodTeamMembers: 'Скрыть членов команды этого POD в разделе поиска POD (В настоящее время видимо)',
  technicalDetails: 'Технические детали',
  currentTeamSize: 'Текущий размер команды',
  communicationDetails: 'Детали коммуникации',
  podReview: 'Отзыв о POD',
  rating: 'Рейтинг',
  writeReview: 'Написать отзыв',
  shareYourExperience: 'Поделитесь своим опытом с этим POD...',
  submitReview: 'Отправить отзыв',
  viewPod: 'Просмотр POD',
  managePod: 'Управление POD',
  editPod: 'Редактировать POD',
  skillsAndExperience: 'Навыки и опыт',
  reviews: 'Отзывы',
  documents: 'Документы',
  otherInfo: 'Другая информация',
  noWorkExperienceDataAvailable: 'Данные об опыте работы недоступны',
  selectART: 'Выбрать ART',
  selectAnART: 'Выбрать ART',
  jiraConfiguration: 'Настройка Jira',
  jiraProjectKey: 'Ключ проекта Jira',
  jiraURL: 'URL Jira',
  jiraAdminEmail: 'Электронная почта администратора Jira',
  jiraAdminAPIToken: 'API токен администратора Jira',
  jiraOpenStoryBugStatus: 'Статус открытой истории/бага Jira',
  jiraClosedStoryBugStatus: 'Статус закрытой истории/бага Jira',
  gitHubConfiguration: 'Настройка GitHub',
  gitHubUsername: 'Имя пользователя GitHub',
  gitHubAPIToken: 'API токен GitHub',
  gitHubRepositoryName: 'Название репозитория GitHub',
  circleCIConfiguration: 'Настройка CircleCI',
  circleCIGitHubUsername: 'Имя пользователя GitHub CircleCI',
  circleCIGitHubRepository: 'Репозиторий GitHub CircleCI',
  circleCIAPIToken: 'API токен CircleCI',
  sonarQubeConfiguration: 'Настройка SonarQube',
  sonarQubeCloudURL: 'URL SonarQube Cloud',
  sonarQubeAPIToken: 'API токен SonarQube',
  awsConfiguration: 'Настройка AWS',
  awsAccessKeyID: 'ID ключа доступа AWS',
  awsSecretAccessKey: 'Секретный ключ доступа AWS',
  awsRegion: 'Регион AWS',
  bitBucketConfiguration: 'Настройка BitBucket',
  bitBucketUsername: 'Имя пользователя BitBucket',
  bitBucketAppPassword: 'Пароль приложения BitBucket',
  bitBucketWorkspace: 'Рабочее пространство BitBucket',
  openAIConfiguration: 'Настройка OpenAI',
  openAIToken: 'Токен OpenAI',
  storyPointsCalculation: 'Расчет очков истории',
  uploadStoryPointsCalculationFile: 'Загрузить файл расчета очков истории',
  currentFile: 'Текущий файл',
  notifications: 'Уведомления',
  markAllAsRead: 'Отметить все как прочитанные',
  tryAgain: 'Попробовать снова',
  noNotificationsToDisplay: 'Нет уведомлений для отображения',
  viewAllNotifications: 'Просмотреть все уведомления',
  enterMultipleEmailsSeparatedByCommas: 'Введите несколько электронных писем, разделенных запятыми',
  addEmailAddressesToInvite: 'Добавьте адреса электронной почты для приглашения новых участников',
  emailInvitationGuidelines: 'Рекомендации по приглашению по электронной почте',
  inviteesWillReceiveInstructions: 'Приглашенные получат инструкции для присоединения к этому POD',
  theyWillNeedToCreateAccount: 'Им нужно будет создать учетную запись, если у них ее еще нет',
  noCandidatesAvailable: 'Кандидаты недоступны',
  sendEmailInvites: 'Отправить приглашения по электронной почте',

  processingDataAndGeneratingInsights: 'Обработка данных и генерация аналитики',
  retroHistory: 'История ретроспектив',
  filterByMember: 'Фильтр по участнику',
  podProductivity: 'Продуктивность POD',
  totalTasks: 'Общее количество задач',
  completed: 'Завершено',
  clearFilters: 'Очистить фильтры',
  totalActivities: 'Общее количество активностей',
  pendingApproval: 'Ожидает одобрения',
  sortBy: 'Сортировать по',
  editSolution: 'Редактировать решение',
  cannotDeleteAssociatedWithARTs: 'Невозможно удалить - связано с ART',
  editART: 'Редактировать ART',
  createdDate: 'Дата создания',
  podDetails: 'Детали POD',
  currentARTProject: 'Текущий ART/Проект',
  artProject: 'ART/Проект',
  selectAvailability: 'Выбрать доступность',
  selectSkill: 'Выбрать навык',
  selectTimezone: 'Выбрать часовой пояс',
  selectLocation: 'Выбрать местоположение',
  selectBudget: 'Выбрать бюджет',
  podMember: 'Участник POD',
  addToPod: 'Добавить в POD',
  talentDetails: 'Детали таланта',
  reviewsFeedback: 'Отзывы и обратная связь',
  noEducationDataAvailable: 'Данные об образовании недоступны',
  noCertificationDataAvailable: 'Данные о сертификации недоступны',
  clientReview: 'Отзыв клиента',
  noReviewsAvailableYet: 'Отзывы пока недоступны',
  noClientReviews: 'Этот талант пока не получил отзывов от клиентов',
  resumeAvailable: 'Резюме доступно',
  viewDownloadResume: 'Просмотреть или скачать резюме кандидата',
  noResumeAvailable: 'Резюме недоступно',
  noResumeUploaded: 'Этот талант не загрузил резюме.',
  codingAssessment: 'Оценка программирования',
  assessmentAvailable: 'Оценка доступна',
  viewAssessmentResults: 'Просмотреть результаты оценки программирования кандидата',
  noAssessmentAvailable: 'Оценка недоступна',
  noAssessmentCompleted: 'Этот талант не завершил оценку программирования.',
  partnerCompanyDetails: 'Детали компании-партнера',
  companyIntroductionVideo: 'Видео представления компании',
  videoNotSupported: 'Ваш браузер не поддерживает видео тег.',
  location: 'Местоположение',
  noPodsMatchingCriteria: 'Не найдено POD, соответствующих вашим критериям',
  hirePod: 'Нанять POD',
  notificationHistory: 'История уведомлений',
  filter: 'Фильтр',
  allNotifications: 'Все уведомления',
  markSelected: 'Отметить выбранные',
  unread: 'Непрочитанные',
  noNotificationsFound: 'Уведомления не найдены',
  searchNotifications: 'Поиск уведомлений...',
subscriptionManagement: 'Управление Подписками',
  choosePlanPrompt: 'Выберите план, который лучше всего подходит вашим потребностям и масштабируется с вашим ростом',
  cancelSubscription: 'Отменить Подписку',
  choosePlan: 'Выбрать План',
  noPlansAvailable: 'Нет Доступных Планов',
  noPlansHelpText: 'Пожалуйста, проверьте позже или обратитесь в службу поддержки за помощью.',
  currentPlanDetails: 'Детали Текущего Плана',
  renewalDate: 'Дата Продления',
  subscriptionId: 'ID Подписки',
  paymentMethod: 'Способ Оплаты',
  cardHolder: 'Владелец Карты',
  expires: 'Истекает',
  brand: 'Бренд',
  billingHistory: 'История Счетов',
  noInvoiceHistory: 'История счетов недоступна',
  needHelp: 'Нужна Помощь?',
  supportText: 'Если у вас есть вопросы о наших планах подписки или нужна помощь, наша команда поддержки здесь, чтобы помочь вам.',
  contactSupport: 'Связаться с Поддержкой',
  completeSubscription: 'Завершите Вашу Подписку',
  planDetails: 'Детали Плана',
  planName: 'Название Плана',
  basePrice: 'Базовая Цена',
  numberOfUsers: 'Количество Пользователей',
  billingCycle: 'Цикл Выставления Счетов',
  orderSummary: 'Сводка Заказа',
  annualDiscount: 'Годовая Скидка',
  billingPeriod: 'Период Выставления Счетов',
  tax: 'Налог',
  totalWithTax: 'Итого с Налогом',
  annually: 'ежегодно',
  continue: 'Продолжить',
  subscriptionSuccessful: 'Подписка Успешна!',
  thankYouSubscribing: 'Спасибо за подписку на',
  subscriptionActivated: 'Ваша подписка была успешно активирована.',
  goToDashboard: 'Перейти в Панель',
  addPaymentMethod: 'Добавить Способ Оплаты',
  cardNumber: 'Номер Карты',
  cardholderName: 'Имя Владельца Карты',
  expiryMonth: 'Месяц Истечения',
  expiryYear: 'Год Истечения',
  postalCode: 'Почтовый Индекс',
  addCard: 'Добавить Карту',
  paymentChoice: 'Использовать Существующую Карту или Добавить Новую Карту',
  existingCardText: 'У вас уже есть существующая карта, оканчивающаяся на',
  useExistingCardPrompt: 'Хотите ли вы использовать ее для этой подписки?',
  useExistingCard: 'Использовать Существующую Карту',
  addNewCard: 'Добавить Новую Карту',
  processing: 'Обработка...',
  subscriptionSuccessDetails: 'прошла успешно!',
  accessAllFeatures: 'Теперь вы можете получить доступ ко всем функциям, включенным в ваш план подписки.',
  editCardDetails: 'Редактировать Детали Карты',
  managerInvite: 'Приглашение Менеджера',
  talentInvite: 'Приглашение Таланта',
  invitePodManagers: 'Введите E-Mail для Приглашения Менеджеров Подразделения',
  enterEmail: 'Введите E-Mail',
  invite: 'Пригласить',
  yourInvoices: 'Ваши Счета',
  noInvoices: 'У вас нет счетов.',
  getCountIsseswithNoCritria: 'Получить количество задач без критериев приемки',
  amountDue: 'Сумма к Оплате',
  amountPaid: 'Оплаченная Сумма',
  noActiveSubscription: 'У вас нет активного плана подписки. Пожалуйста, нажмите на ссылку "Подписаться", чтобы добавить подписку.',
 noActiveSubscriptionStart: 'У вас нет активного плана подписки. Пожалуйста, нажмите на',
  subscribe: 'Подписаться',
  noActiveSubscriptionEnd: 'ссылку, чтобы добавить подписку.'};

export default messagesRu;